import { ThemeUICSSObject } from '@apia/theme';
import { error } from './error';
/* IMPORT HERE */

export const common: ThemeUICSSObject = {
  error,
  /* PREPEND HERE */
};
